<template>
    <div>
        <div v-if="dadosGrupoLocal.length > 0">
            <b-card  v-for="(data,index) in dadosGrupoLocal" v-bind:key="index" no-body style="border: none; margin-bottom: 1rem; display: flex; ">
                <b-card-header header-tag="header" class="w-100 h-100 p-0 mb-0" role="tab" style="background-color: #008144; color: white; font-size: 13px;">
                    <div  variant="info" class="head-mes d-flex align-items-center">
                        <div class="title-left pl-3">
                            <div class="button-selecionado" v-if="data.novaEtapa === false">
                                <div>
                                    <div class="button-lista" :id="data.etapaId"  @click="SelecionarEtapa(data.etapaId)"><i class="fas fa-check" style="color: rgb(19, 59, 26); font-size: 9px;" v-if="data.checkEtapa === true"></i></div>
                                </div>
                            </div>

                            <div class="img-descricao"  v-on:click="toggleSection(index)">
                                <div class="title-colapse-mirror">
                                    <img class="img_tipo_campo"  :src="data.tipoMetadado == false ? imgAvalicao : imgAnexo"  v-b-tooltip.hover :title="data.tipoMetadado == false ? 'Formulario Avaliação' : 'Formulario Anexo'">
                                </div>
                                <div class="title-colapse-mirror">
                                    {{ data.nivelPrioridadeEtapa != undefined || data.nivelPrioridadeEtapa != null ? data.nivelPrioridadeEtapa + ' - ' + data.descricaoEtapa : data.descricaoEtapa }}
                                </div>
                            </div>
                        </div>
                        <div class="componente" v-on:click="toggleSection(index)">
                            <i class="fas fa-pen" style="font-size: 13px; color: white; margin-right: 0.5rem; margin-top: 2px"  @click="abrirModalAddEtapa(data.etapaId, data.novaEtapa, data)"></i>
                            <i class="fas fa-times" v-if="data.novaEtapa === true" @click="tabelaApagaEtapaEstatica(data.etapaId)" style="font-size: 13px; color: white; margin-right: 0.5rem; margin-top: 2px" v-b-tooltip.hover :title="'Remover Novo Item'"></i>
                            <i v-if="!openSections.includes(index)" class="fas fa-angle-down arrow-angel" style="color: white; font-size: 16px;"></i>
                            <i v-else class="fas fa-angle-up arrow-angel" style="color: white; font-size: 16px;" ></i>
                        </div>
                    </div>
                </b-card-header>
                <b-collapse
                    :visible="openSections.includes(index)"
                    id="id"
                    role="tabpanel"
                    ref="testeacor"
                    style="margin-bottom: 0;"
                    >
                    <b-card-body style="padding: 0rem">
                        <div class="collapse-add-SubEtapa">
                            <div class="button-collap-add-risco" @click="abrirModalAddASubEtapa(data.etapaId, data.novaEtapa, null, data.tipoMetadado, data)"><i class="fas fa-plus"></i> ADICIONAR SUBETAPA</div>
                        </div>
                        <div style="width: 100%;" v-if="data.subEtapas && data.subEtapas.length > 0" >
                            <div v-for="(sub,index) in data.subEtapas" v-bind:key="index">
                                <div class="container_subGrupo">
                                    <div style="width: 90%; display: flex; gap: 1rem; align-items: center;">
                                        <div class="button-selecionado-subetapa pl-4" v-if="sub.exclusao === false && sub.adicao === false">
                                            <div class="button-lista" :id="sub.etapaId" @click="SelecionarPergunta(sub, data.etapaId, null)"><i class="fas fa-check" style="color: rgb(19, 59, 26); font-size: 9px;" v-if="sub.checkTodosItens === true"></i></div>
                                        </div>
                                        <div style="width: 90%; display: flex; gap: 0.5rem; margin: 0 0.6rem 0 0; align-items: center;" @click="abrirSubEtapa(sub, data.etapaId, data.novaEtapa, data.tipoMetadado)">
                                            <div class="subEtapa_descricao">
                                                {{ sub.nivelPrioridadeEtapa === null|| sub.nivelPrioridadeEtapa === undefined ? sub.descricaoEtapa : sub.nivelPrioridadeEtapa + ' - ' + sub.descricaoEtapa }}
                                            </div>
                                            <div class="tag" v-if="sub.edicao === true">
                                                <div class="tag_identificacao" :style="{'background-color': sub.colorStatus, 'color': sub.colorFonte}"> {{ sub.descricaoEdicao }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 10%; display: flex; gap: 1rem; justify-content: end;">
                                        <div class="subEtapa_detalhes" @click="abrirModalAddASubEtapa(data.etapaId, data.novaEtapa, sub, null, data)">
                                            <i class="fas fa-pen"></i>
                                        </div>
                                        <div class="icon_container" v-if="sub.exclusao == true || sub.adicao == true" >
                                            <i class="fas fa-times" style="color: rgb(136, 22, 22); font-size: 14px" v-b-tooltip.hover :title="sub.exclusao == true ? 'Remover Edições do tipo Exclusão' : 'Remover Novo Item'"  @click="RemoverEdicao(data.etapaId, sub.etapaId)"></i>
                                        </div>
                                        <div class="subEtapa_detalhes" @click="abrirSubEtapa(sub, data.etapaId, data.novaEtapa)">
                                            <i class="fas fa-angle-up" v-if="sub.expandir === true" style="font-size: 17px;"></i>
                                            <i class="fas fa-angle-down" v-if="sub.expandir === false" style="font-size: 17px;"></i>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="sub.expandir === true">
                                    <SubGroupDetail
                                    ref="subGroup"
                                    :equipamento="equipamento"
                                    :templateid="templateid"
                                    :preRequisito="false"
                                    :dadosSubGrupo="[sub]"
                                    :grupoId="grupoId"
                                    :etapaCriada="etapaCriada"
                                    :metadado="metadado"
                                    @NovaPerguntaGrupo="NovaPerguntaGrupo"
                                    @addNovaPerguntaParaSubEtapa="addNovaPerguntaParaSubEtapa"
                                    @addNovaPerguntaEtapaSubCriada="addNovaPerguntaEtapaSubCriada"
                                    @ExcluirPerguntaPerguntaEquipamentoCriado="ExcluirPerguntaPerguntaEquipamentoCriado"
                                    @ExcluirPerguntaEquipamento="ExcluirPerguntaEquipamento"
                                    @RemoverEdicaoExcluirPerguntaEquipamento="RemoverEdicaoExcluirPerguntaEquipamento"
                                    @EditaEquipamentoPergunta="EditaEquipamentoPergunta"
                                    @editarEmMemoriaNovaPerguntaEtapaSubCriada="editarEmMemoriaNovaPerguntaEtapaSubCriada"
                                    @editarEmMemoriaNovaPerguntaParaSubEtapa="editarEmMemoriaNovaPerguntaParaSubEtapa"
                                    @editarEmMemoriaNovaPerguntaParaEtapa="editarEmMemoriaNovaPerguntaParaEtapa"
                                    @ExcluirPerguntaTemplateDetalheCriado="ExcluirPerguntaTemplateDetalheCriado"
                                    @ExcluirPerguntaTemplateDetalheSubEtapa="ExcluirPerguntaTemplateDetalheSubEtapa"
                                    @ExcluirPerguntaTemplateDetalheEtapa="ExcluirPerguntaTemplateDetalheEtapa"
                                    @RemoverEdicaoExcluirPerguntaTemplate="RemoverEdicaoExcluirPerguntaTemplate"
                                    @ExcluirPerguntaTemplate="ExcluirPerguntaTemplate"
                                    @EditaTemplatePergunta="EditaTemplatePergunta"
                                    @EditaTemplateNovaPergunta="EditaTemplateNovaPergunta"
                                    @addNovaPerguntaImagem="addNovaPerguntaImagem"
                                    @EditarNovaPerguntaImagem="EditarNovaPerguntaImagem"
                                    @removerImagemNova="removerImagemNova"
                                    >
                                    </SubGroupDetail>
                                </div>
                            </div>
                        </div>
                        <div class="container_img" v-else>
                            <div class="titulo_sem_registro">Nenhum registro encontrado</div>
                            <div class="subtitulo_sem_registro">Adicione um novo registro para iniciar a Etapa</div>
                        </div>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>

        <div class="container_img_geral" v-if="dadosGrupoLocal.length === 0 && dadosSubEtapa.length === 0">
            <img  class="img_notFound_geral" :src="notFound">
            <div class="titulo_sem_registro_geral">Nenhum registro encontrado</div>
            <div class="subtitulo_sem_registro_geral">Adicione um novo registro para iniciar a etapa</div>
            <button class="button_geral" @click="abrirModalAddEtapa">
                <i class="fas fa-plus"></i>ADICIONAR REGISTRO
            </button>
        </div>
        <addGroup
            ref="modalAddEtapa"
            :subEtapa="subEtapa"
            :Editar="Editar"
            :etapaCriada="etapaCriada"
            :equipamento="equipamento"
            @tabelaNovaEtapa="tabelaNovaEtapa"
            @addNovaEtapa="addNovaEtapa"
            @editaSubEtapa="editaSubEtapa"
            @novaSubEtapa="novaSubEtapa"
            @addNovaSubEtapa="addNovaSubEtapa"
            @tabelaEditaEtapa="tabelaEditaEtapa"
            @editarEtapa="editarEtapa"
            @tabelaSubEditaEtapa="tabelaSubEditaEtapa"
            @addNovaSubEtapaObjSemNovaEtapa="addNovaSubEtapaObjSemNovaEtapa">
        </addGroup>
        <deleteQuestion
          ref="modal_Excluir_Grupo"
          :templateid="templateid"
          :subGrupo="subGrupo"
          @deleteItensSubGrupo="deleteItensSubGrupo">
        </deleteQuestion>    </div>
</template>

<script>
import GroupDetail from './GroupDetail'
export default GroupDetail
</script>
  <style scoped>
    .img-descricao {
        display: flex;
        justify-content: initial;
        width: 100%;
        gap: 10px
    }
    .img_tipo_campo {
        width: 25px;
    }
    .tag{
        display: flex;
        justify-content: initial;
        align-content: center;
        align-items: center;
        width: 30%;
        padding: 0 0.3rem 0 0.8rem;
    }
    .tag_identificacao{
        width: fit-content;
        height: 1.6rem;
        text-align: center;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font: normal normal 600 10px / 24px Segoe UI;
        padding: 0 5px 0 5px;
        font-weight: bold;
    }
    .subEtapa_descricao {
        width: fit-content;
        font-family: 'Segoe UI';
    }
    .subEtapa_detalhes {
        display: flex;
        justify-content: end;
        align-items: center;
        color: #717171
    }
    .icon_container {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .container_subGrupo {
        margin-top: 0.8rem;
        background-color: #F4F4F4;
        padding: 8px 10px 8px 5px;
        cursor: pointer;
        width: 100%;
        gap: 1rem;
        display: flex;
    }
    .title-left{
        display: flex;
        gap: 1rem;
        width: 100%;
        height: 100%;
        align-items: center;
    }
    .title-colapse-mirror{
        font-weight: bold;
        font-family: 'Segoe UI';
        font-size: 13px;
    }
    .componente{
        font-size: 18px;
        color: black;
        padding-top: 9px;
        padding-left: 15px;
        display: flex;
    }
    .arrow-angel{
        font-size: 30px;
        color: black;
        padding-right: 20px;
        padding-bottom: 10px;
    }
    .collapse-add-SubEtapa{
        height: 2rem;
        border-left: 2px dashed #d2d2d2;
        border-right: 2px dashed #d2d2d2;
        border-bottom: 2px dashed #d2d2d2;
        background-color: white;
        display: flex;
        justify-content: center;
    }
    .button-collap-add-risco{
        display: flex;
        justify-content: center;
        cursor: pointer;
        gap: 10px;
        color: #1C6228;
        font: normal normal 600 11px / 24px Segoe UI;
        align-items: center;
    }
    /* estilização checkbox */
    .button-selecionado{
        display: flex;
        width: 2%;
        align-items: center;
        justify-content: center;
    }
    .button-selecionado-subetapa{
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .button-lista{
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1rem;
        height: 1rem;
        border-radius: 12%;
        background-color: #fff;
        border: 1px solid #c4c4c4;
    }
    .button-lista.clicked {
        background-color: rgb(203, 233, 207);
        border: 1px solid rgb(81 134 91)
    }

     /* Style para validação sem registro */
    .button{
        margin-top: 2rem;
        font: normal normal 600 12px / 21px Segoe UI;
        outline: transparent;
        border: transparent;
        border-radius: 4px;
        text-transform: uppercase;
        width: 15rem;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        height: 37px;
        background-color: #008144;
        color: white;
    }
    .container_img{
        display: flex;
        justify-content: center;
        align-content: center;
        width: 100%;
        margin-top: 1rem;
        margin-bottom: 1rem;
        align-items: center;
        flex-direction: column;
    }
    .img_notFound{
        width: 10%;
        height: fit-content;
    }
    .titulo_sem_registro {
        margin-top: 0.5rem;
        font-weight: 600;
        font: normal normal normal 15px/33px Segoe UI;
        color: #008148;
    }
    .subtitulo_sem_registro {
        font: normal normal normal 12px/33px Segoe UI;
        letter-spacing: -0.3px;
        color: #4F4C4D;
    }

      /* Style para validação sem registro Geral*/
  .button_geral{
    margin-top: 2rem;
    font: normal normal 600 12px / 21px Segoe UI;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 15rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    height: 37px;
    background-color: #008144;
    color: white;
  }
  .container_img_geral{
    display: flex;
    justify-content: center;
    align-content: center;
    width: 100%;
    margin-top: 5rem;
    margin-bottom: 5rem;
    align-items: center;
    flex-direction: column;
  }
  .img_notFound_geral{
    width: 20%;
    height: fit-content;
  }
  .titulo_sem_registro_geral {
    margin-top: 1rem;
    font: normal normal normal 28px/33px Segoe UI;
    color: #008148;
  }
  .subtitulo_sem_registro_geral {
    font: normal normal normal 16px/33px Segoe UI;
    letter-spacing: -0.3px;
    color: #4F4C4D;
  }
 </style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/TemplateDetail/GroupDetail/GroupDetail.vue